<template>
  <div class="user-admin">
    <b-form :hidden="form_input_hide">
      <input id="user-id" type="hidden" v-model="userF.id" />
      <b-row>
        <b-col md="2" sm="12">
          <b-form-group label="Cpf:" label-for="user-cpf">
            <the-mask v-if="
              userParams.admin >= 1 ||
              (userParams.tipoUsuario >= 1 &&
                (userParams.master >= 1 || userParams.gestor >= 1))
            " id="user-cpf" class="form-control" type="text" v-model="userF.cpf" :mask="['###########']"
              placeholder="Informe o CPF do usuário..." :disabled="!(userParams.tipoUsuario >= 1 && userParams.master >= 1)
                " />
            <span v-else class="form-control">{{ userF.cpf }}</span>
          </b-form-group>
        </b-col>
        <b-col md="4" sm="12">
          <b-form-group label="Nome:" label-for="user-name">
            <b-form-input id="user-name" type="text" v-model="userF.name" v-if="
              userParams.admin >= 1 ||
              (userParams.tipoUsuario >= 1 &&
                (userParams.master >= 1 || userParams.gestor >= 1))
            " placeholder="Informe o Nome do Usuário..." class="form-control" :disabled="!(userParams.tipoUsuario >= 1 && userParams.master >= 1)
              " />
            <span v-else class="form-control">{{ userF.name }}</span>
          </b-form-group>
        </b-col>
        <b-col md="2" sm="12">
          <b-form-group label="Telefone:" label-for="user-telefone">
            <the-mask v-if="
              userParams.admin >= 1 ||
              (userParams.tipoUsuario >= 1 &&
                (userParams.master >= 1 || userParams.gestor >= 1))
            " id="user-telefone" class="form-control" type="text" v-model="userF.telefone" :mask="['(##) #########']"
              placeholder="Informe o Telefone do usuário..." :disabled="!(userParams.tipoUsuario >= 1 && userParams.master >= 1)
                " />
            <span v-else class="form-control disabled">{{
              userF.telefone
            }}</span>
          </b-form-group>
        </b-col>
        <b-col md="4" sm="12">
          <b-form-group label="E-mail:" label-for="user-email">
            <b-form-input v-if="
              userParams.admin >= 1 ||
              (userParams.tipoUsuario >= 1 &&
                (userParams.master >= 1 || userParams.gestor >= 1))
            " id="user-email" type="text" v-model="userF.email" :disabled="!(userParams.tipoUsuario >= 1 && userParams.master >= 1)
              " placeholder="Informe o E-mail do Usuário..." class="form-control" />
            <span v-else class="form-control">{{
              userF.email ? userF.email : "Não declarado"
            }}</span>
          </b-form-group>
        </b-col>
        <b-col md="2" sm="12" v-if="userF.id">
          <b-form-group label="Status:" label-for="user-status">
            <b-form-input
              id="user-status"
              type="text"
              class="form-control"
              :value="userStatusLabel"
              readonly
            />
          </b-form-group>
        </b-col>
        <b-col md="2" sm="12" v-if="userParams.admin >= 1">
          <b-form-group label="Tipo Usuário:" label-for="user-tipoUsuario">
            <b-form-select :options="tipos" v-model="userF.tipoUsuario" id="user-tipoUsuario" />
          </b-form-group>
        </b-col>
        <b-col md="2" sm="6" v-if="
          userParams.id != userF.id &&
          userParams.tipoUsuario >= 1 &&
          (userParams.master >= 1 || userParams.gestor >= 1)
        ">
          <b-form-group label="Gestor:" label-for="user-gestor">
            <b-form-select :options="sn" v-model="userF.gestor" id="user-gestor" :disabled="!(userParams.tipoUsuario >= 1 && userParams.master >= 1)
              " />
          </b-form-group>
        </b-col>
        <b-col md="2" sm="6" v-else-if="
          userParams.id == userF.id &&
          userParams.tipoUsuario >= 1 &&
          (userParams.master >= 1 || userParams.gestor >= 1)
        ">
          <b-form-group label="Gestor:" label-for="user-master">
            <span class="form-control form-control">{{
              userF.gestor ? "Sim" : "Não"
            }}</span>
          </b-form-group>
        </b-col>
        <b-col md="2" sm="6" v-if="
          userParams.id != userF.id &&
          userParams.tipoUsuario >= 1 &&
          (userParams.master >= 1 || userParams.gestor >= 1)
        ">
          <b-form-group label="Master(Gestão total):" label-for="user-master">
            <b-form-select :options="sn" v-model="userF.master" id="user-master" :disabled="!(userParams.tipoUsuario >= 1 && userParams.master >= 1)
              " />
          </b-form-group>
        </b-col>
        <b-col md="2" sm="6" v-else-if="
          userParams.id == userF.id &&
          userParams.tipoUsuario >= 1 &&
          (userParams.master >= 1 || userParams.gestor >= 1)
        ">
          <b-form-group label="Master(Gestão total):" label-for="user-master">
            <span class="form-control form-control">{{
              userF.master ? "Sim" : "Não"
            }}</span>
          </b-form-group>
        </b-col>
        <b-col md="2" sm="12" v-if="
          (userParams.admin >= 1 ||
            (userParams.tipoUsuario == 1 && userParams.master >= 1))
        ">
          <b-form-group label="Multi Cliente:" label-for="user-multiCliente">
            <b-form-select :options="multiCli" v-model="userF.multiCliente" id="user-multiCliente" :disabled="!(userParams.tipoUsuario >= 1 && userParams.master >= 1)
              " />
          </b-form-group>
        </b-col>
        <b-col md="4" sm="12" v-if="
          userParams.consignatario == 3 &&
          userF.consignatario == 3 &&
          (userParams.admin >= 1 ||
            (userParams.tipoUsuario == 1 && userParams.master >= 1))
        ">
          <b-form-group label="Convênio:" label-for="user-convenio">
            <b-form-select :class="`input-group-flex-${userParams &&
              userParams.tipoUsuario &&
              userParams.tipoUsuario.toString() == '2'
              ? '25'
              : '40'
              }`" id="user-convenio" :options="convenios" v-model="userF.convenio" />
          </b-form-group>
        </b-col>
        <b-col md="2" sm="12" v-if="
          !(userParams.consignatario == 3 && userF.consignatario == 3) &&
          // userF.multiCliente < 2 &&
          (userParams.admin >= 1 ||
            (userParams.tipoUsuario == 1 && userParams.master >= 1))
        ">
          <b-form-group label="Cliente:" label-for="user-cliente">
            <b-form-select :class="`input-group-flex-${userParams &&
              userParams.tipoUsuario &&
              userParams.tipoUsuario.toString() == '2'
              ? '25'
              : '40'
              }`" id="user-cliente" :options="clientes" @input="loadDominios(userF.cliente)" v-model="userF.cliente" />
          </b-form-group>
        </b-col>
        <b-col md="2" sm="12" v-if="
          !(userParams.consignatario == 3 && userF.consignatario == 3) &&
          // userF.multiCliente == 0 &&
          (userParams.admin >= 1 ||
            (userParams.tipoUsuario == 1 && userParams.master >= 1))
        ">
          <b-form-group label="Domínio no Cliente:" label-for="user-dominio">
            <b-form-select :class="`input-group-flex-${userParams &&
              userParams.tipoUsuario &&
              userParams.tipoUsuario.toString() == '2'
              ? '25'
              : '40'
              }`" id="user-dominio" :options="dominios" v-model="userF.dominio" />
          </b-form-group>
        </b-col>
        <b-col md="2" sm="12" v-if="userParams.gestor >= 1 && userParams.tipoUsuario >= 2">
          <b-form-group label="Cadastros:" label-for="user-cad_servidores">
            <b-form-select :options="alcadas" v-model="userF.cad_servidores" id="user-cad_servidores" :disabled="!(userParams.gestor >= 1 && userParams.tipoUsuario == 2)
              " />
          </b-form-group>
        </b-col>
        <b-col md="2" sm="12" v-if="userParams.gestor >= 1 && userParams.tipoUsuario >= 2">
          <b-form-group label="Financeiro:" label-for="user-financeiro">
            <b-form-select :options="alcadas" v-model="userF.financeiro" id="user-financeiro" :disabled="!(userParams.gestor >= 1 && userParams.tipoUsuario == 2)
              " />
          </b-form-group>
        </b-col>
        <b-col md="2" sm="12" v-if="userParams.gestor == 1 || userParams.master == 1">
          <b-form-group label="Contratos:" label-for="user-con_contratos">
            <b-form-select :options="alcadas" v-model="userF.con_contratos" id="user-con_contratos" :disabled="!(userParams.tipoUsuario >= 1 && userParams.master >= 1)
              " />
          </b-form-group>
        </b-col>
        <b-col md="2" sm="12" v-if="userF.tipoUsuario > 0 && userParams.admin >= 1">
          <b-form-group label="Consignatário:" label-for="user-multiCliente">
            <b-form-select v-if="userParams.tipoUsuario >= 2" :options="consignatarios" v-model="userF.consignatario"
              id="user-multiCliente" :disabled="userParams.admin < 2" />
          </b-form-group>
        </b-col>
        <b-col md="2" sm="12" v-if="userParams.gestor >= 1 && userParams.tipoUsuario >= 2">
          <b-form-group label="Orgão" label-for="user-cad_orgao">
            <b-form-select :options="alcadas" v-model="userF.cad_orgao" id="user-cad_orgao" :disabled="!(userParams.gestor >= 1 && userParams.tipoUsuario == 2)
              ">
              Orgão
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="!form_input_hide" class="user-admin-form-actions-row">
        <b-col cols="12">
          <div class="d-flex flex-wrap align-items-center">
            <b-button
              v-if="
                userParams.master >= 1 ||
                ((user.id == userF.id ||
                  userParams.admin >= 1 ||
                  userParams.master == 1) &&
                  ['new', 'save'].includes(mode))
              "
              variant="primary"
              class="mr-2 mb-2"
              @click="save"
              v-b-tooltip.hover
              title="Salvar registro"
            >
              {{ userF.id ? "Salvar" : "Salvar novo usuário" }}
            </b-button>
            <b-button
              v-if="userParams.gestor == 1 && mode === 'remove'"
              variant="outline-danger"
              class="mr-2 mb-2"
              @click="remove"
              v-b-tooltip.hover
              title="Remover registro"
            >
              Excluir
            </b-button>
            <b-button
              v-if="['view', 'new', 'save'].includes(mode)"
              class="mr-2 mb-2"
              @click="reset"
              v-b-tooltip.hover
              title="Cancelar ou sair da edição ou exibição"
            >
              Cancelar
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <h2>
            Se desejar alterar sua senha faça isso utilizando a opção disponível
            na tela de login 😉
          </h2>
        </b-col>
      </b-row>
    </b-form>
    <div v-if="userParams.admin >= 2">
      <p>mode: {{ mode }}</p>
      <p>userF: {{ userF }}</p>
      <p>userParams: {{ userParams }}</p>
    </div>

    <div
      class="user-admin-toolbar mb-1"
      v-if="showUserGrid"
    >
      <b-input-group size="md" class="user-admin-search">
        <template #prepend>
          <b-input-group-text><i class="fa fa-search"></i></b-input-group-text>
        </template>
        <b-form-input
          type="text"
          placeholder="Digite aqui: nome, e-mail ou CPF"
          title="Para CPF, utilize apenas números"
          v-b-tooltip.hover
          v-model="keyword"
          @input="loadUsers"
          ref="keyword"
        />
        <b-input-group-text slot="append">
          <span>{{ keyword_res }}&nbsp;</span>
        </b-input-group-text>
        <b-btn
          slot="append"
          variant="outline-info"
          size="md"
          @click="
            keyword = '';
            loadUsers();
          "
        >
          Limpar
        </b-btn>
        <b-btn
          v-if="
            userParams.admin >= 2 ||
            (userParams.tipoUsuario >= 1 && userParams.master >= 1)
          "
          slot="append"
          variant="success"
          size="md"
          @click="newUser"
        >
          + Novo perfil
        </b-btn>
      </b-input-group>
      <b-form-select
        v-if="showGridConvenioFilter"
        size="md"
        v-model="gridFilterDomainCli"
        :options="gridFilterOptions"
        class="user-admin-grid-filter"
      />
    </div>
    <b-table hover striped responsive :items="users" :fields="tableFields" v-if="showUserGrid">
      <template v-slot:cell(name)="data">
        <span v-html="data.value"></span>
      </template>
      <template v-slot:cell(actions)="row">
        <b-button :variant="row.item.admin >= 1 && userParams.admin == 0
          ? 'light'
          : 'outline-warning'
          " size="sm" @click="loadUser(row.item)" class="mr-1" :disabled="row.item.admin >= 1 && userParams.admin == 0 ? 'disabled' : false
            " v-b-tooltip.hover :title="userParams.master >= 1 ? 'Editar registro' : 'Visualizar registro'
              " href="#header">
          <i class="fa fa-pencil" v-if="userParams.master >= 1"></i>
          <i class="fa fa-eye" v-else></i>
        </b-button>
        <b-button v-if="userParams.master >= 1" :variant="row.item.admin >= 1 || getOwn(row.item.id)
          ? 'light'
          : 'outline-danger'
          " size="sm" @click="loadUser(row.item, 'remove')" class="mr-1" :disabled="row.item.admin >= 1 || getOwn(row.item.id) ? 'disabled' : false
            " v-b-tooltip.hover :title="getOwn(row.item.id)
              ? 'Você não pode e excluir o próprio registro'
              : row.item.admin
                ? 'Usuário Adm não pode ser removido'
                : 'Remover registro'
              " href="#header">
          <i class="fa fa-trash"></i>
        </b-button>
        <!-- <b-button :variant="getOwn(row.item.id) ? 'outline-dark' : 'light'" size="sm" @click="requestPassReset"
          :disabled="getOwn(row.item.id) ? false : 'disabled'" v-b-tooltip.hover :title="
            getOwn(row.item.id)
              ? 'Editar senha'
              : 'Apenas o usuário pode alterar a própria senha'
          " href="#header">
          <i class="fa fa-key"></i>
        </b-button> -->
      </template>
    </b-table>
    <b-pagination size="md" v-model="page" :total-rows="count" :per-page="limit" v-if="page > 1" />
    <!-- v-if="(userParams.tipoUsuario >= 1 && (userParams.master >= 1 || userParams.gestor >= 1))" /> -->
  </div>
</template>

<script>
// import { userKey } from "@/global";
import { showError } from "@/global";
// import { baseAuthApiUrl } from "@/env";
import { baseApiUrl } from "@/env";
// import { decodeToken } from "@/config/globalFacilities";
import { titleCase, capitalizeFirst } from "@/config/globalFacilities";
import axios from "axios";
import { mapState } from "vuex";
import { cpf } from "cpf-cnpj-validator";
import { TheMask } from "vue-the-mask";

export default {
  name: "UserAdmin",
  components: { TheMask },
  data: function () {
    return {
      userParams: {},
      mode: "view",
      userF: {},
      users: [],
      dominios: [],
      convenios: [],
      capitalize: capitalizeFirst,
      clientes: [],
      cpfHide: "",
      form_input_hide: true,
      cpfValid: false,
      keyword: "",
      keyword_res: "",
      gridFilterDomainCli: "",
      page: 1,
      limit: 0,
      count: 0,
      tipos: [
        { value: "0", text: "Servidor" },
        { value: "1", text: "Consignatário" },
        { value: "2", text: "Operador" },
      ],
      sn: [
        { value: "0", text: "Não" },
        { value: "1", text: "Sim" },
      ],
      admins: [
        { value: "0", text: "Não" },
        { value: "1", text: "Supt" },
        { value: "2", text: "Dev" },
      ],
      multiCli: [
        { value: "0", text: "Não (0)" },
        { value: "1", text: "Troca Domínio (1)" },
        { value: "2", text: "Troca Cliente (2)" },
      ],
      consignatarios: [
        { value: "1", text: "Banco do Brasil" },
        { value: "2", text: "Caixa Econômica" },
        { value: "3", text: "Bradesco" },
      ],
      alcadas: [
        { value: "0", text: "Acesso Negado" },
        { value: "1", text: "Pesquisa" },
        { value: "2", text: "Insere" },
        { value: "3", text: "Edita" },
        { value: "4", text: "Adm (pode excluir)" },
      ],
      userStatuses: [
        { value: 0, text: "Aguardando liberação" },
        { value: 1, text: "Aguardando" },
        { value: 8, text: "Suspenso por token" },
        { value: 9, text: "Suspenso" },
        { value: 10, text: "Ativo" },
        { value: 19, text: "Senha expirada" },
        { value: 99, text: "Excluído" },
      ],
      fields: [
        {
          key: "id",
          label: "Código",
          sortable: true,
          thClass: "d-none",
          tdClass: "d-none",
        },
        {
          key: "name",
          label: "Nome",
          sortable: true,
          formatter: (value) => titleCase(value),
        },
        { key: "email", label: "E-mail", sortable: true },
        // {
        //   key: "averbaOnline", label: "Averba", sortable: true,
        //   formatter: (value) => (value == "1" ? "Sim" : "Não"),
        // },
        {
          key: "gestor",
          label: "Gestor",
          sortable: true,
          formatter: (value) => (value == "1" ? "Sim" : "Não"),
        },
        {
          key: "master",
          label: "Master",
          sortable: true,
          formatter: (value) => (value == "1" ? "Sim" : "Não"),
        },
        {
          key: "tipoUsuario",
          label: "Tipo usuário",
          sortable: true,
          formatter: (value) =>
            value == "0"
              ? "Servidor"
              : value == "1"
                ? "Consignatário"
                : "Operador",
        },
        { key: "actions", label: "Ações", thClass: "col-actions3" },
      ],
    };
  },
  methods: {
    getOwn(id) {
      return id == this.user.id;
    },
    formatClienteDominio(item) {
      return titleCase(
        [item.cliente, item.dominio]
          .filter(Boolean)
          .join(" ")
          .replace(/_/g, " ")
      );
    },
    getGetAlcadasLabel(value) {
      let status = "";
      switch (value) {
        case 1:
          status = "Pode Pesquisar";
          break;
        case 2:
          status = "Pode Inserir";
          break;
        case 3:
          status = "Pode Editar";
          break;
        case 4:
          status = "Pode Excluir";
          break;
        default:
          status = "Acesso negado";
          break;
      }
      return status;
    },
    loadClientes() {
      const param = {
        dominio: "root",
        meta: "clientName",
        forceDominio: true,
      };
      axios.post(`${baseApiUrl}/params`, param).then((res) => {
        this.clientes = res.data.data.map((data) => {
          return {
            value: data.value,
            text: capitalizeFirst(data.label.replace("_", " ")),
          };
        });
      });
    },
    loadDominios(cliente) {
      const param = {
        dominio: cliente,
        meta: "domainName",
        forceDominio: true,
      };
      axios.post(`${baseApiUrl}/params`, param).then((res) => {
        this.dominios = res.data.data.map((data) => {
          return {
            value: data.value,
            text: capitalizeFirst(data.value),
          };
        });
      });
    },
    loadConvenios() {
      const url = `${baseApiUrl}/consignatarios/f/gcvn?id_banco=${this.userParams.consignatario || this.userF.consignatario}&fields=nome,cliente,dominio`;
      return axios.get(url).then((res) => {
        this.convenios = res.data.data.map((data) => {
          return {
            value: `${data.cliente}|${data.dominio}`,
            text: data.nome,
          };
        });
      });
    },
    loadUsers() {
      let url = `${baseApiUrl}/users?page=${this.page}&key=${this.keyword}`;
      if (this.gridFilterDomainCli) {
        const [cliente, dominio] = this.gridFilterDomainCli.split("|");
        url += `&cliente=${encodeURIComponent(cliente)}&dominio=${encodeURIComponent(dominio)}`;
      }
      axios.get(url).then((res) => {
        this.users = res.data.data;
        if (this.users.length == 1) this.loadUser(this.users[0], "view");
        else {
          this.userF = {};
          this.form_input_hide = true;
        }
        this.count = res.data.count;
        this.limit = res.data.limit;
        this.keyword_res = `#${this.count}`;
      });
    },
    findUser(cpf) {
      // validar minimamente o cpf
      if (this.mode == "new" && cpf && cpf.length == 11) {
        // this.newUser();
        const url = `${baseApiUrl}/users-cpf/${cpf}`;
        axios.get(url).then((res) => {
          if (res.data.id && !res.data.id_emp) {
            this.loadUser(res.data, "new");
          } else if (res.data.id && res.data.id_emp) {
            this.$toasted.global.defaultInfo({
              msg: "O CPF informado já encontra-se cadastrado!",
            });
            // Se o usuário pertence ao domínio
            if (
              res.data.id_emp == this.userParams.id_emp ||
              this.userParams.master == 1
            )
              this.loadUser(res.data, "view");
          }
        });
      }
    },

    async save() {
      // if (!this.setValidCpf()) {
      //   this.$toasted.global.defaultError({ msg: "CPF inválido!" });
      //   return;
      // }
      const method = this.userF.id ? "put" : "post";
      const id = this.userF.id ? `/${this.userF.id}` : "";
      let url = `${baseApiUrl}/users${id}`;
      // if (this.mode === "new") url = `${baseAuthApiUrl}/signup`;
      const objBody = { ...this.userF };
      if (this.userParams.consignatario == 3 && objBody.convenio) {
        const partes = objBody.convenio.split("|");
        objBody.cliente = partes[0];
        objBody.dominio = partes[1];
        delete objBody.convenio;
      }
      // if (objBody.gestor) objBody.gestor = 1;
      // else objBody.gestor = 0;

      // if (objBody.master) objBody.master = 1;
      // else objBody.master = 0;

      try {
        const response = await axios[method](url, objBody);

        // Verifica se há um ID na resposta para confirmar sucesso
        if (response.data && (response.data.id || this.userF.id)) {
          this.mode = "view";
          this.loadUsers();
          this.$toasted.global.defaultSuccess({
            msg: "Usuário salvo com sucesso!",
          });
        } else {
          // Se não há ID, pode ser uma mensagem de erro
          const errorMsg =
            response.data || "Erro desconhecido ao salvar usuário";
          this.$toasted.global.defaultError({ msg: errorMsg });
        }
      } catch (error) {
        let errorMessage = "Erro ao salvar usuário";

        if (error.response) {
          // Erro com resposta do servidor (status 400, 401, 500, etc.)
          if (error.response.status === 400 || error.response.status === 200) {
            // Para status 400 e 200 (que a API retorna com erro), pega a mensagem da resposta
            errorMessage = error.response.data || "Dados inválidos";
          } else if (error.response.status === 401) {
            errorMessage = "Não autorizado";
          } else if (error.response.status === 500) {
            errorMessage = "Erro interno do servidor";
          } else {
            errorMessage =
              error.response.data || `Erro ${error.response.status}`;
          }
        } else if (error.request) {
          // Erro de rede (sem resposta do servidor)
          errorMessage = "Erro de conexão com o servidor";
        } else {
          // Outros erros
          errorMessage = error.message || "Erro desconhecido";
        }

        this.$toasted.global.defaultError({ msg: errorMessage });
      }
    },
    remove() {
      const id = this.userF.id;
      axios
        .delete(`${baseApiUrl}/users/${id}`)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.reset();
        })
        .catch(showError);
    },
    loadUser(userF, mode = "save") {
      this.mode = mode;
      this.userF = { ...userF };
      const cpf = this.userF.cpf;
      if (cpf && cpf.length)
        this.cpfHide = `${cpf.substring(0, 2)}${cpf.substring(
          8,
          9
        )}-${cpf.substring(9)}`;
      this.form_input_hide = false;
      this.userF.domain = this.loadDominios(this.userF.cliente);
      if (this.userParams.consignatario == 3)
        this.userF.convenio = `${this.userF.cliente}|${this.userF.dominio}`;
      this.userF.averbaOnline = this.userF.averbaOnline == 1;
      if (mode != "remove") this.userF.confirmPassword = this.userF.password;
      if (mode === "key")
        this.userF.confirmPassword = this.userF.password = null;
      if (this.userParams.consignatario == 3) this.loadConvenios();
    },
    newUser() {
      this.mode = "new";
      this.userF = {
        id_cadas: null,
        id_emp: this.userParams.id_emp,
        cliente: this.userParams.cliente,
        dominio: this.userParams.dominio,
        admin: 0,
        gestor: 0,
        master: 0,
        multiCliente: 2,
        consignatario: this.userParams.consignatario,
        tipoUsuario: this.userParams.tipoUsuario,
        pesoAverbacao: 4,
        cad_servidores: 1,
        financeiro: 1,
        con_contratos: 1,
        cad_orgao: 0,
        f_ano: this.userParams.f_ano,
        f_mes: this.userParams.f_mes,
        f_complementar: this.userParams.f_complementar,
        tkn_api: null,
        averbaOnline: false,
        isForceNew: true, // Essa propriedade identifica que é um master criando o usuário
      };
      this.form_input_hide = false;
      if (this.userF.consignatario == 3) this.loadConvenios();
    },
    setValidCpf() {
      if (this.userF.cpf.length == 11) {
        // valida o CPF
        this.cpfValid = cpf.isValid(this.userF.cpf);
      } else this.cpfValid = false;
      return this.cpfValid;
    },
    loadUserParams() {
      const url = `${baseApiUrl}/users/${this.user.id}`;
      axios.get(url).then((res) => {
        this.userParams = res.data;
        if (this.userParams.tipoUsuario == 1 && this.userParams.master >= 1) {
          this.gridFilterDomainCli = "";
          this.loadConvenios().then(() => this.loadUsers());
        } else {
          this.loadUsers();
        }
      });
    },
    reset() {
      this.keyword = "";
      this.page = 1;
      this.limit = 0;
      this.count = 0;
      if (this.userParams.admin >= 1) {
        this.mode = "view";
        this.userF = {};
        this.form_input_hide = true;
        this.loadUsers();
        this.dominios = [];
        this.clientes = [];
      } else this.$router.push({ path: "/" });
    },
  },
  mounted() {
    this.loadUserParams();
    this.loadClientes();
  },
  watch: {
    page() {
      this.loadUsers();
    },
    gridFilterDomainCli() {
      this.page = 1;
      this.loadUsers();
    },
    // ler o cpf e buscar o usuário em tempo real findUser(userF.cpf)
    "userF.cpf": function (val) {
      this.findUser(val);
    },
  },
  computed: {
    ...mapState(["user"]),
    showUserGrid() {
      const params = this.userParams;
      return params.admin >= 1
        || (params.tipoUsuario == 1 && params.master >= 1)
        || (params.tipoUsuario == 2 && params.gestor >= 1);
    },
    showGridConvenioFilter() {
      return this.userParams.tipoUsuario == 1 && this.userParams.master >= 1;
    },
    gridFilterOptions() {
      return [
        { value: "", text: "Todos convênios" },
        ...this.convenios,
      ];
    },
    tableFields() {
      const fields = [...this.fields];
      const nomeIndex = fields.findIndex((field) => field.key === "name");
      if (this.userParams.admin >= 1) {
        fields.splice(nomeIndex + 1, 0, {
          key: "clienteDominio",
          label: "Cliente",
          formatter: (_value, _key, item) => this.formatClienteDominio(item),
        });
      } else if (this.userParams.tipoUsuario == 1 && this.userParams.master >= 1) {
        const idIndex = fields.findIndex((field) => field.key === "id");
        fields.splice(idIndex + 1, 0, {
          key: "convenio",
          label: "Convênio",
          formatter: (_value, _key, item) => this.formatClienteDominio(item),
        });
      }
      return fields;
    },
    userStatusLabel() {
      const item = this.userStatuses.find(
        (status) => status.value == this.userF.status
      );
      return item ? item.text : "Desconhecido";
    },
  },
};
</script>

<style>
.alcada0 {
  color: #212529;
}

.alcada1 {
  color: #28a745;
}

.alcada2 {
  color: #007bff;
}

.alcada3 {
  color: #ffc107;
}

.alcada4 {
  color: #dc3545;
}

.alcadas {
  text-align: center;
}

.user-admin-form-actions-row {
  margin-top: 0.25rem;
}

.user-admin-toolbar {
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
}

.user-admin-search {
  flex: 1 1 auto;
  min-width: 0;
}

.user-admin-grid-filter {
  flex: 0 0 240px;
  max-width: 280px;
  height: auto;
}
</style>
